import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { UntilDestroy } from '@ngneat/until-destroy';
import Alert from '../alert.model';
import { AlertService } from '../alert.service';
import { AlertComponent } from '../alert/alert.component';

const MAX_OVERLAY_ALERTS = 2;
const MAX_INLINE_ALERTS = 2;

@UntilDestroy()
@Component({
  selector: 'mbs-alert-container',
  templateUrl: 'alert-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AlertComponent],
  host: {
    class: 'mbs-alert-container',
    '[style.width]': 'width()',
    '[style.min-width]': 'minWidth()',
    '[style.max-width]': 'maxWidth()'
  }
})
export class AlertContainerComponent {
  private alertService = inject(AlertService);

  public readonly width = input<string | null>(null);
  public readonly minWidth = input<string | null>(null);
  public readonly maxWidth = input<string | null>(null);

  private readonly alerts = toSignal(this.alertService.alerts$, { initialValue: [] as Alert[] });

  protected readonly inlineAlerts = computed(() =>
    this.alerts()
      .filter((a) => !a.overlay)
      .slice(0, MAX_INLINE_ALERTS)
  );

  protected readonly overlayAlerts = computed(() =>
    this.alerts()
      .filter((a) => a.overlay)
      .slice(0, MAX_OVERLAY_ALERTS)
  );

  removeAlert(alert: Alert): void {
    this.alertService.close(alert);
  }
}
